import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../auth/auth.repository';
import { environment } from '@env/environment';

/**
 * Adds JWT Authorization header to HTTP requests to the API URL.
 *
 * @param req HttpRequest instance
 * @param next Next handler in the Http pipeline
 * @returns An Observable of the Http event stream
 */
export const JwtInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authRepository = inject(AuthRepository);

  // Check if the request URL starts with the API URL
  const isApiUrl = req.url.startsWith(environment.serverUrl);
  
  // Skip adding token to refresh endpoint - it uses refresh_token in body instead
  const isRefreshEndpoint = req.url.includes('/refresh-token');
  
  if (isApiUrl && !isRefreshEndpoint) {
    const token = authRepository.getAccessToken();
    const api_key = environment.api_key_studema_settings;

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'X-APIKEY': '' + api_key,
        },
      });
    }
  }

  // Pass the updated request to the next handler
  return next(req);
};
